
// import ModifySearch from "./ModifySearch";
import Header from "../../Components/Header";
import ForexSearch from '../Forex/ForexSearch';
const Forex = () => {

  return (
    <>
<Header></Header>
       <section className='Forex_top_banner'>
      <ForexSearch />
    </section>
<section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Sale.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Purchase</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Sale.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Sale</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Forex.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Forex Card</h5>
                </a>
            </div>
                      
        </div>
     </div>
           
            
        </div>    
    </section>
    </>
  );
};
export default Forex;